import { QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import queryClient from "./configs/react-query/query-client.js";
import { ThemeContext } from "./contexts/ThemeContext";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./index.css";

// Get theme from localStorage or default to dark theme
const savedTheme = localStorage.getItem("theme");
const initialTheme = savedTheme ? savedTheme === "dark" : true; // Default to dark if no saved theme

export const Root = () => {
  const [isDark] = useState(initialTheme);

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", isDark ? "dark" : "light");
  }, [isDark]);

  return (
    // <StrictMode>
    <ThemeContext.Provider value={{ isDark }}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
      
      {/* Global Toast Container */}
      <ToastContainer hideProgressBar closeButton={false}
      />
    </ThemeContext.Provider>
    // </StrictMode>
  );
};

createRoot(document.getElementById("root")).render(<Root />);
